module.exports = __webpack_public_path__ + "img/icone-protecao.22ce84d4.svg";